import type { ColDef } from 'ag-grid-community'
import { createInvoiceColumns } from './invoiceColumns'
import { createBolColumns } from './bolColumns'
import type { MatchInvoice, MatchBol } from '@api/useSupplierReconciliation/types/match'

interface HelperFunctions {
  isItemMatched: (item: MatchInvoice | MatchBol) => boolean
  getLinkedNumbers: (item: MatchInvoice | MatchBol) => string[]
  findLinkedItems?: (item: MatchInvoice | MatchBol) => (MatchInvoice | MatchBol)[]
  combinedData?: {
    invoices: any[]
    bols: any[]
  }
}

interface ActionHandlers {
  handleAddToMatch: (type: 'invoice' | 'bol', item: MatchInvoice | MatchBol, itemId: string, matchId?: string) => void
  handleRemoveFromMatch: (type: 'invoice' | 'bol', itemId: string, item?: MatchInvoice | MatchBol) => void
  pendingItems: (MatchInvoice | MatchBol)[]
}

/**
 * Creates column definitions for the manage match grid
 * Supports both invoice and BOL search modes
 * @param searchType - Whether we're searching for invoices or BOLs
 * @param helpers - Helper functions for checking matched status and getting linked numbers
 * @returns Column definitions tailored to the data structure
 */
export function createManageMatchColumnDefs(
  searchType: 'invoice' | 'bol',
  helpers: HelperFunctions,
  actions: ActionHandlers,
  timezone?: string
): ColDef[] {
  // Return completely different column sets based on search type
  if (searchType === 'invoice') {
    return createInvoiceColumns(helpers, actions, timezone)
  }
  return createBolColumns(helpers, actions, timezone)
}

// Re-export types for external use
export type { HelperFunctions, ActionHandlers }

// Re-export renderers for direct use if needed
export { DocumentNumberRenderer } from './renderers/DocumentNumberRenderer'
export { ManageMatchActionRenderer } from './renderers/ManageMatchActionRenderer'
